import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import omit from 'lodash/omit';
import { isFunction } from '@utiljs/is';

var DropMenuItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DropMenuItem, _React$PureComponent);

  var _super = _createSuper(DropMenuItem);

  function DropMenuItem() {
    var _this;

    _classCallCheck(this, DropMenuItem);

    _this = _super.apply(this, arguments);

    _this.handleClick = function () {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onMenuClick = _this$props.onMenuClick;
      var restDomProps = omit(_this.props, ['onMenuClick']);

      if (isFunction(onClick)) {
        onClick(restDomProps);
      }

      if (isFunction(onMenuClick)) {
        onMenuClick(restDomProps);
      }
    };

    return _this;
  }

  _createClass(DropMenuItem, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          label = _a.label,
          restProps = __rest(_a, ["label"]);

      var restDomProps = omit(restProps, ['onMenuClick']);
      return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", _Object$assign({}, restDomProps, {
        onClick: this.handleClick
      }), label));
    }
  }]);

  return DropMenuItem;
}(React.PureComponent);

DropMenuItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  className: PropTypes.string,
  onClick: PropTypes.func
};
DropMenuItem.defaultProps = {
  label: '',
  className: null,
  onClick: null
};
export default DropMenuItem;